/* AUTO-GENERATED from Capsi_Pack_Ingredient_Reference.md — do not hand-edit. */
window.CAPSI_PACK_DATA = {
 "ingredients": {
  "10B Probiotic": {
   "why": "This doctor-formulated daily probiotic delivers 10 billion live cultures per capsule, featuring a blend of 10 well-researched Lactobacillus and Bifidobacterium strains.",
   "tags": "Vegan · Non-GMO"
  },
  "Alpha Lipoic Acid": {
   "why": "A powerful broad range antioxidant supports cardiovascular health and liver detoxification, while reducing oxidative stress.",
   "tags": "Vegan"
  },
  "Ashwagandha": {
   "why": "Ashwagandha root extract is a calming adaptogen often used by athletes that may enhance mental clarity, improve energy, and support the body’s stress response system.",
   "tags": "Vegan · Gluten-free · Non-GMO"
  },
  "BCAA": {
   "why": "Branched-chain amino acids (BCAA) are the essential amino acids leucine, isoleucine and valine.",
   "tags": "Vegan · Dairy-free"
  },
  "Berberine": {
   "why": "Berberine is a potent bioactive compound.",
   "tags": "Vegan · Gluten-free · Non-GMO"
  },
  "Biotin": {
   "why": "Biotin aids the body in converting nutrients into energy and the metabolization of sugars, fats, and amino acids.",
   "tags": "Vegetarian · Gluten-free"
  },
  "Boron": {
   "why": "Boron participates in hydroxylation reactions, supporting bone mineral metabolism and membrane function, along with promoting healthy hormonal balance.",
   "tags": "Vegetarian · Gluten-free · Non-GMO"
  },
  "Calcium Citrate": {
   "why": "Calcium citrate is readily digested and absorbed.",
   "tags": "Vegan · Dairy-free"
  },
  "Carnitine": {
   "why": "Carnitine Tartrate is a form of the amino acid that is commonly used for exercise performance.",
   "tags": "Vegan · Dairy-free"
  },
  "CoQ10": {
   "why": "Ubiquinone (CoEnzyme Q-10) is found in every cell in the body.",
   "tags": "Vegan"
  },
  "Cordyceps": {
   "why": "Cordyceps Mushrooms supports exercise performance and overall health.",
   "tags": "Vegetarian · Gluten-free"
  },
  "Creatine": {
   "why": "Creatine is a naturally occurring compound that plays a crucial role in the production of energy during high-intensity, short-duration activities.",
   "tags": "Vegan · Dairy-free"
  },
  "D Complex": {
   "why": "Balanced formula containing vitamins A, D, non-soy E, and both forms of K2, for optimal utilization.",
   "tags": "Dairy-free · Non-GMO"
  },
  "DHEA": {
   "why": "DHEA is the most abundant naturally occurring steroid hormone in the bloodstream and declines with age and stress.",
   "tags": "Vegetarian · Gluten-free"
  },
  "DIM": {
   "why": "Diindolylmethane (DIM) is a compound found in cruciferous vegetables like broccoli, cabbage, and Brussels sprouts.",
   "tags": "Vegan · Dairy-free"
  },
  "Fenugreek": {
   "why": "Fenugreek is an herb that has been used in alternative medicine, and it contains compounds that may have potential health-promoting properties.",
   "tags": "Vegan · Dairy-free"
  },
  "Glutamine": {
   "why": "Glutamine is an amino acid that plays several important roles in the body.",
   "tags": "Certified Vegan · Dairy-free"
  },
  "Green Coffee Extract": {
   "why": "Green Coffee Bean Extract provides the protective antioxidant compound chlorogenic acid.",
   "tags": "Vegan · Gluten-free · Non-GMO"
  },
  "Green Tea Extract": {
   "why": "Green tea extract is rich in antioxidants, particularly catechins such as epigallocatechin gallate (EGCG).",
   "tags": "Vegan · Dairy-free"
  },
  "Herbal Sleep Blend": {
   "why": "Sleep Blend combines five potent plant ingredients aimed at promoting relaxation and enhancing sleep.",
   "tags": "Vegan · Dairy-free · Non-GMO"
  },
  "Hyaluronic Acid": {
   "why": "Hyaluronic acid is found naturally in joint fluid and skin, and ours is derived from type II chicken collagen.",
   "tags": "Gluten-free · Non-GMO"
  },
  "Iron": {
   "why": "Iron is a mineral that the body needs for growth and development.",
   "tags": "Certified Vegan · Non-GMO"
  },
  "Lion's Mane": {
   "why": "Lion's mane (Hericium erinaceus) is a mushroom that has been used for centuries across Asia in cooking and Traditional Chinese medicine.",
   "tags": "Vegan · Gluten-free · Non-GMO"
  },
  "Magnesium": {
   "why": "Magnesium glycinate is a specific form of magnesium supplement that is highly bioavailable, meaning it is easily absorbed by the body.",
   "tags": "Certified Vegan · Dairy-free"
  },
  "Melatonin SR": {
   "why": "Melatonin is a hormone produced by the pineal gland in the brain, which regulates the body's sleep/wake cycle.",
   "tags": "Vegan · Dairy-free"
  },
  "Methyl B-Complex": {
   "why": "A high-potency, high bioavailable, complete range of B vitamins in their coenzymated (active) forms.",
   "tags": "Vegan"
  },
  "Multivitamin": {
   "why": "This comprehensive multi is an ideal foundation to an optimal nutritional regimen.",
   "tags": ""
  },
  "Mushroom Immune": {
   "why": "Traditional medicine has long valued mushrooms for their many health benefits.",
   "tags": "Vegan · Gluten-free · Non-GMO"
  },
  "NAC": {
   "why": "NAC (N-Acetylcysteine) is the supplement form of the amino acid cysteine, typically found in various high-protein foods.",
   "tags": "Vegan · Dairy-free"
  },
  "NR": {
   "why": "Nicotinamide Riboside (NR) is designed to boost NAD+ levels, is critical for cellular metabolism and energy production.",
   "tags": "Vegan · Dairy-free"
  },
  "Omega 3": {
   "why": "Omega-3 fats have long been heralded for supporting a healthy inflammatory response.",
   "tags": "Gluten-free · Non-GMO"
  },
  "Quercetin": {
   "why": "Quercetin is a flavonoid, a type of plant pigment found in various fruits, vegetables, and grains.",
   "tags": "Vegan · Dairy-free"
  },
  "Resveratrol": {
   "why": "Trans-resveratrol from Japanese Knotweed (Polygonum cuspidatum), promotes cardiovascular, cognitive and cellular health, along with mitochondrial function, and antioxidant support.",
   "tags": "Vegetarian · Gluten-free"
  },
  "Rhodiola": {
   "why": "Rhodiola (Rhodiola rosea) is an adaptogenic herb that grows throughout Europe and Asia.",
   "tags": "Vegan · Gluten-free · Non-GMO"
  },
  "Saw Palmetto": {
   "why": "Saw Palmetto is widely recognized for its role in supporting urinary comfort and prostate health in men, and hair, skin, and hormone health in both men and women..",
   "tags": "Vegetarian · Gluten-free · Non-GMO"
  },
  "Soothing Fiber Formula": {
   "why": "Active Aloe is a potent gastrointestinal soother for both constipation and diarrhea.",
   "tags": "Vegan · Gluten-free"
  },
  "Theanine": {
   "why": "Theanine is the primary amino acid in green tea, which is traditionally understood to help reduce stress and uplift mood.",
   "tags": ""
  },
  "Trace Minerals": {
   "why": "A comprehensive, hypoallergenic trace mineral supplement.",
   "tags": "Vegan · Dairy-free"
  },
  "Tribulus": {
   "why": "Tribulus terrestris is an herb that has been traditionally used in various cultures for its potential medicinal properties, including its purported ability to enhance libido and testosterone levels.",
   "tags": "Vegan · Dairy-free"
  },
  "Triphala": {
   "why": "Triphala is an Ayurvedic herbal combination know for various gastrointestinal health benefits.",
   "tags": "Vegan · Gluten-free"
  },
  "Turmeric": {
   "why": "Curcumin C3 Complex contains a minimum 95% curcuminoids, composed of curcumin, demethoxycurcumin, and bisdemethoxycurcumin, and is free from impurities and contaminants.",
   "tags": "Vegetarian · Dairy-free · Non-GMO"
  },
  "Tyrosine": {
   "why": "Tyrosine is required to produce dopamine, norepinephrine and epinephrine, as well as thyroid hormones.",
   "tags": "Vegan · Dairy-free"
  },
  "Vegan Glucosamine": {
   "why": "Glucosamine is a well-known joint support ingredient that is vegetarian/vegan friendly and not shellfish-derived.",
   "tags": "Vegan · Gluten-free"
  },
  "Vegan Omega": {
   "why": "This supplement provides a plant-based source of essential fatty acids, including Omega-3 and Omega-6, derived from algal oil.",
   "tags": "Certified Vegan · Gluten-free · Non-GMO"
  },
  "Vitamin C": {
   "why": "As an essential vitamin only obtained through diet or supplementation, Vitamin C supports the production of collagen, connective tissue, bone, cartilage, and red blood cells.",
   "tags": "Vegan · Dairy-free"
  },
  "Zinc": {
   "why": "Zinc is an essential mineral that plays a crucial role in various physiological functions within the body.",
   "tags": "Vegan · Non-GMO"
  }
 },
 "packs": {
  "allergy-pack": {
   "name": "Allergy Pack",
   "pills": [
    {
     "name": "D Complex",
     "dose": "5,000 IU/125 mcg",
     "summary": "5,000 IU/125 mcg vitamin D3 balanced with the fat-soluble vitamins, A, E, K2 (MK-4 & MK-7), for optimal utilization."
    },
    {
     "name": "NAC",
     "dose": "600mg",
     "summary": "600mg N-Acetyl Cysteine supports the master antioxidant glutathione in protecting DNA, aids liver detoxification, and maintains healthy respiratory tissue."
    },
    {
     "name": "Omega 3",
     "dose": "1000mg",
     "summary": "1000mg Omega-3 fatty acids support heart health, and aid in the function of the brain, liver, muscles, and joints. This omega-3 formula has been molecularly distilled to remove PCBs, dioxins, pesticides, and heavy metals."
    },
    {
     "name": "Quercetin",
     "dose": "500mg",
     "summary": "500mg Quercetin is a flavonoid used for its antioxidant and anti-inflammatory properties."
    },
    {
     "name": "Trace Minerals",
     "dose": "",
     "summary": "A comprehensive, hypoallergenic trace mineral supplement with 11 essential trace elements needed for optimal health. This formula is iron-free for those who don't need extra iron from supplements."
    },
    {
     "name": "Vitamin C",
     "dose": "1000mg",
     "summary": "1000mg Vitamin C helps to support the production of collagen, connective tissue, bone, cartilage, and red blood cells as well as strengthen immune function."
    }
   ]
  },
  "antioxidant-pack": {
   "name": "Antioxidant Pack",
   "pills": [
    {
     "name": "Alpha Lipoic Acid",
     "dose": "500mg",
     "summary": "500mg Alpha Lipoic Acid is a powerful antioxidant that supports a healthy cardiovascular system and aids in liver detoxification."
    },
    {
     "name": "NAC",
     "dose": "600mg",
     "summary": "600mg N-Acetyl Cysteine supports the master antioxidant glutathione in protecting DNA, aids liver detoxification, and maintains healthy respiratory tissue."
    },
    {
     "name": "Quercetin",
     "dose": "500mg",
     "summary": "500mg Quercetin is a flavonoid used for its antioxidant and anti-inflammatory properties."
    },
    {
     "name": "Resveratrol",
     "dose": "250mg",
     "summary": "250mg Resveratrol promotes cardiovascular and cognitive health, mitochondrial function, and antioxidant support."
    },
    {
     "name": "Trace Minerals",
     "dose": "",
     "summary": "A comprehensive, hypoallergenic trace mineral supplement with 11 essential trace elements needed for optimal health. This formula is iron-free for those who don't need extra iron from supplements."
    },
    {
     "name": "Vitamin C",
     "dose": "1000mg",
     "summary": "1000mg Vitamin C helps to support the production of collagen, connective tissue, bone, cartilage, and red blood cells as well as strengthen immune function."
    }
   ]
  },
  "beauty-pack": {
   "name": "Beauty Pack",
   "pills": [
    {
     "name": "Biotin",
     "dose": "5000mcg",
     "summary": "5000mcg Biotin aids the body in converting nutrients into energy as well as promoting strong and healthy nails, skin, and hair."
    },
    {
     "name": "D Complex",
     "dose": "5,000 IU/125 mcg",
     "summary": "5,000 IU/125 mcg vitamin D3 balanced with the fat-soluble vitamins, A, E, K2 (MK-4 & MK-7), for optimal utilization."
    },
    {
     "name": "Hyaluronic Acid",
     "dose": "60mg",
     "summary": "60mg Hyaluronic Acid provides hyaluronic acid from type II chicken collagen that supports mobility and overall joint, skin, and hair health."
    },
    {
     "name": "Omega 3",
     "dose": "1000mg",
     "summary": "1000mg Omega-3 fatty acids support heart health, and aid in the function of the brain, liver, muscles, and joints. This omega-3 formula has been molecularly distilled to remove PCBs, dioxins, pesticides, and heavy metals."
    },
    {
     "name": "Quercetin",
     "dose": "500mg",
     "summary": "500mg Quercetin is a flavonoid used for its antioxidant and anti-inflammatory properties."
    },
    {
     "name": "Resveratrol",
     "dose": "250mg",
     "summary": "250mg Resveratrol promotes cardiovascular and cognitive health, mitochondrial function, and antioxidant support."
    }
   ]
  },
  "bone-builder-pack": {
   "name": "Bone Builder Pack",
   "pills": [
    {
     "name": "10B Probiotic",
     "dose": "10 billion",
     "summary": "10 billion live probiotic cultures support digestive health and a balanced gut microbiome. Includes Lactobacillus and Bifidobacterium strains, and prebiotic fibers like inulin and FOS to help nourish beneficial bacteria and enhance their effectiveness."
    },
    {
     "name": "Calcium Citrate",
     "dose": "160mg",
     "summary": "160mg - Highly bioavailable calcium to support bone mineral composition and bone health."
    },
    {
     "name": "D Complex",
     "dose": "5,000 IU/125 mcg",
     "summary": "5,000 IU/125 mcg vitamin D3 balanced with the fat-soluble vitamins, A, E, K2 (MK-4 & MK-7), for optimal utilization."
    },
    {
     "name": "Hyaluronic Acid",
     "dose": "60mg",
     "summary": "60mg Hyaluronic Acid provides hyaluronic acid from type II chicken collagen that supports mobility and overall joint, skin, and hair health."
    },
    {
     "name": "Magnesium",
     "dose": "133mg",
     "summary": "133mg Magnesium Glycinate is a highly bioavailable essential mineral that supports muscle relaxation, without causing digestive upset."
    },
    {
     "name": "Trace Minerals",
     "dose": "",
     "summary": "A comprehensive, hypoallergenic trace mineral supplement with 11 essential trace elements needed for optimal health. This formula is iron-free for those who don't need extra iron from supplements."
    }
   ]
  },
  "brain-pack": {
   "name": "Brain Pack",
   "pills": [
    {
     "name": "Ashwagandha",
     "dose": "500mg",
     "summary": "500mg Ashwagandha root and extract formula is an adaptogen that supports stress & anxiety, muscle function & strength, testosterone production, focus, and memory."
    },
    {
     "name": "Lion's Mane",
     "dose": "500mg",
     "summary": "500mg organic Lion's Mane helps calm the mind, support memory function, aid overall nervous system health, and enhance immune function. Other benefits include liver and adrenal support, energy production, muscle endurance, and strength."
    },
    {
     "name": "Methyl B-Complex",
     "dose": "",
     "summary": "B3 along with seven other B vitamins provide a complete range of essential B vitamins in their coenzymated (active) forms."
    },
    {
     "name": "Resveratrol",
     "dose": "250mg",
     "summary": "250mg Resveratrol promotes cardiovascular and cognitive health, mitochondrial function, and antioxidant support."
    },
    {
     "name": "Theanine",
     "dose": "200mg",
     "summary": "200mg Theanine helps decrease stress and uplift mood by increasing levels of GABA, serotonin and dopamine."
    }
   ]
  },
  "clear-skin-pack": {
   "name": "Clear Skin Pack",
   "pills": [
    {
     "name": "10B Probiotic",
     "dose": "10 billion",
     "summary": "10 billion live probiotic cultures support digestive health and a balanced gut microbiome. Includes Lactobacillus and Bifidobacterium strains, and prebiotic fibers like inulin and FOS to help nourish beneficial bacteria and enhance their effectiveness."
    },
    {
     "name": "NAC",
     "dose": "600mg",
     "summary": "600mg N-Acetyl Cysteine supports the master antioxidant glutathione in protecting DNA, aids liver detoxification, and maintains healthy respiratory tissue."
    },
    {
     "name": "Omega 3",
     "dose": "1000mg",
     "summary": "1000mg Omega-3 fatty acids support heart health, and aid in the function of the brain, liver, muscles, and joints. This omega-3 formula has been molecularly distilled to remove PCBs, dioxins, pesticides, and heavy metals."
    },
    {
     "name": "Turmeric",
     "dose": "700 mg",
     "summary": "700 mg Turmeric is a high potency capsule utilizing C3 Complex®--the most clinically studied turmeric on the market."
    },
    {
     "name": "Vitamin C",
     "dose": "1000mg",
     "summary": "1000mg Vitamin C helps to support the production of collagen, connective tissue, bone, cartilage, and red blood cells as well as strengthen immune function."
    },
    {
     "name": "Zinc",
     "dose": "25mg",
     "summary": "25mg Zinc Picolinate is an essential mineral that plays a crucial role in various physiological functions within the body including our immune system."
    }
   ]
  },
  "energy-pack": {
   "name": "Energy Pack",
   "pills": [
    {
     "name": "Ashwagandha",
     "dose": "500mg",
     "summary": "500mg Ashwagandha root and extract formula is an adaptogen that supports stress & anxiety, muscle function & strength, testosterone production, focus, and memory."
    },
    {
     "name": "Cordyceps",
     "dose": "500mg",
     "summary": "500mg Cordyceps Mushrooms extract supports aids performance by enhancing oxygen utilization and energy production."
    },
    {
     "name": "Green Coffee Extract",
     "dose": "500mg",
     "summary": "500mg Green Coffee extract supports metabolism & weight management"
    },
    {
     "name": "Methyl B-Complex",
     "dose": "",
     "summary": "B3 along with seven other B vitamins provide a complete range of essential B vitamins in their coenzymated (active) forms."
    },
    {
     "name": "Rhodiola",
     "dose": "250mg",
     "summary": "250mg Rhodiola Rosea is an adaptogenic herb used to improve energy and aid the stress response."
    },
    {
     "name": "Tyrosine",
     "dose": "500mg",
     "summary": "500mg Tyrosine promotes a healthy mood, emotional wellness and alertness. Neurotransmitter and thyroid hormone support. Vegan source."
    }
   ]
  },
  "eye-vision-pack": {
   "name": "Eye & Vision Pack",
   "pills": [
    {
     "name": "D Complex",
     "dose": "5,000 IU/125 mcg",
     "summary": "5,000 IU/125 mcg vitamin D3 balanced with the fat-soluble vitamins, A, E, K2 (MK-4 & MK-7), for optimal utilization."
    },
    {
     "name": "Omega 3",
     "dose": "1000mg",
     "summary": "1000mg Omega-3 fatty acids support heart health, and aid in the function of the brain, liver, muscles, and joints. This omega-3 formula has been molecularly distilled to remove PCBs, dioxins, pesticides, and heavy metals."
    },
    {
     "name": "Quercetin",
     "dose": "500mg",
     "summary": "500mg Quercetin is a flavonoid used for its antioxidant and anti-inflammatory properties."
    },
    {
     "name": "Resveratrol",
     "dose": "250mg",
     "summary": "250mg Resveratrol promotes cardiovascular and cognitive health, mitochondrial function, and antioxidant support."
    },
    {
     "name": "Trace Minerals",
     "dose": "",
     "summary": "A comprehensive, hypoallergenic trace mineral supplement with 11 essential trace elements needed for optimal health. This formula is iron-free for those who don't need extra iron from supplements."
    },
    {
     "name": "Vitamin C",
     "dose": "1000mg",
     "summary": "1000mg Vitamin C helps to support the production of collagen, connective tissue, bone, cartilage, and red blood cells as well as strengthen immune function."
    },
    {
     "name": "Zinc",
     "dose": "25mg",
     "summary": "25mg Zinc Picolinate is an essential mineral that plays a crucial role in various physiological functions within the body including our immune system."
    }
   ]
  },
  "focus-pack": {
   "name": "Focus Pack",
   "pills": [
    {
     "name": "Lion's Mane",
     "dose": "500mg",
     "summary": "500mg organic Lion's Mane helps calm the mind, support memory function, aid overall nervous system health, and enhance immune function. Other benefits include liver and adrenal support, energy production, muscle endurance, and strength."
    },
    {
     "name": "Magnesium",
     "dose": "133mg",
     "summary": "133mg Magnesium Glycinate is a highly bioavailable essential mineral that supports muscle relaxation, without causing digestive upset."
    },
    {
     "name": "Rhodiola",
     "dose": "250mg",
     "summary": "250mg Rhodiola Rosea is an adaptogenic herb used to improve energy and aid the stress response."
    },
    {
     "name": "Theanine",
     "dose": "200mg",
     "summary": "200mg Theanine helps decrease stress and uplift mood by increasing levels of GABA, serotonin and dopamine."
    },
    {
     "name": "Tyrosine",
     "dose": "500mg",
     "summary": "500mg Tyrosine promotes a healthy mood, emotional wellness and alertness. Neurotransmitter and thyroid hormone support. Vegan source."
    }
   ]
  },
  "gut-pack": {
   "name": "Gut Pack",
   "pills": [
    {
     "name": "10B Probiotic",
     "dose": "10 billion",
     "summary": "10 billion live probiotic cultures support digestive health and a balanced gut microbiome. Includes Lactobacillus and Bifidobacterium strains, and prebiotic fibers like inulin and FOS to help nourish beneficial bacteria and enhance their effectiveness."
    },
    {
     "name": "Glutamine",
     "dose": "750mg",
     "summary": "750mg L-Glutamine is an amino acid that supports muscle recovery and aids in digestive health."
    },
    {
     "name": "Quercetin",
     "dose": "500mg",
     "summary": "500mg Quercetin is a flavonoid used for its antioxidant and anti-inflammatory properties."
    },
    {
     "name": "Soothing Fiber Formula",
     "dose": "350mg",
     "summary": "350mg - This soluble fiber blend of aloe, marshmallow, and slippery elm is a potent gut soother for both constipation and diarrhea."
    },
    {
     "name": "Triphala",
     "dose": "500mg",
     "summary": "500mg Triphala is an ayurvedic herb used for gastrointestinal health benefits."
    }
   ]
  },
  "hair-pack": {
   "name": "Hair Pack",
   "pills": [
    {
     "name": "Biotin",
     "dose": "5000mcg",
     "summary": "5000mcg Biotin aids the body in converting nutrients into energy as well as promoting strong and healthy nails, skin, and hair."
    },
    {
     "name": "Hyaluronic Acid",
     "dose": "60mg",
     "summary": "60mg Hyaluronic Acid provides hyaluronic acid from type II chicken collagen that supports mobility and overall joint, skin, and hair health."
    },
    {
     "name": "Omega 3",
     "dose": "1000mg",
     "summary": "1000mg Omega-3 fatty acids support heart health, and aid in the function of the brain, liver, muscles, and joints. This omega-3 formula has been molecularly distilled to remove PCBs, dioxins, pesticides, and heavy metals."
    },
    {
     "name": "Resveratrol",
     "dose": "250mg",
     "summary": "250mg Resveratrol promotes cardiovascular and cognitive health, mitochondrial function, and antioxidant support."
    },
    {
     "name": "Saw Palmetto",
     "dose": "650mg",
     "summary": "650mg of Saw Palmetto extract supports urinary comfort, hormone balance, and healthy DHT regulation in men while promoting hair, skin, and hormone health in both men and women. Features a standardized dose with verified fatty acid content."
    },
    {
     "name": "Trace Minerals",
     "dose": "",
     "summary": "A comprehensive, hypoallergenic trace mineral supplement with 11 essential trace elements needed for optimal health. This formula is iron-free for those who don't need extra iron from supplements."
    }
   ]
  },
  "immune-pack": {
   "name": "Immune Pack",
   "pills": [
    {
     "name": "10B Probiotic",
     "dose": "10 billion",
     "summary": "10 billion live probiotic cultures support digestive health and a balanced gut microbiome. Includes Lactobacillus and Bifidobacterium strains, and prebiotic fibers like inulin and FOS to help nourish beneficial bacteria and enhance their effectiveness."
    },
    {
     "name": "D Complex",
     "dose": "5,000 IU/125 mcg",
     "summary": "5,000 IU/125 mcg vitamin D3 balanced with the fat-soluble vitamins, A, E, K2 (MK-4 & MK-7), for optimal utilization."
    },
    {
     "name": "Mushroom Immune",
     "dose": "525 mg",
     "summary": "525 mg - This mushroom immune formula is a proprietary blend of 14 organically grown mushroom extracts that provide immune and adaptogenic support."
    },
    {
     "name": "Vitamin C",
     "dose": "1000mg",
     "summary": "1000mg Vitamin C helps to support the production of collagen, connective tissue, bone, cartilage, and red blood cells as well as strengthen immune function."
    },
    {
     "name": "Zinc",
     "dose": "25mg",
     "summary": "25mg Zinc Picolinate is an essential mineral that plays a crucial role in various physiological functions within the body including our immune system."
    }
   ]
  },
  "joint-health-pack": {
   "name": "Joint Health Pack",
   "pills": [
    {
     "name": "Boron",
     "dose": "10mg",
     "summary": "10mg Boron is a trace mineral, supporting healthy bone strength and structure. Promotes steroidal hormone balance."
    },
    {
     "name": "Hyaluronic Acid",
     "dose": "60mg",
     "summary": "60mg Hyaluronic Acid provides hyaluronic acid from type II chicken collagen that supports mobility and overall joint, skin, and hair health."
    },
    {
     "name": "Omega 3",
     "dose": "1000mg",
     "summary": "1000mg Omega-3 fatty acids support heart health, and aid in the function of the brain, liver, muscles, and joints. This omega-3 formula has been molecularly distilled to remove PCBs, dioxins, pesticides, and heavy metals."
    },
    {
     "name": "Trace Minerals",
     "dose": "",
     "summary": "A comprehensive, hypoallergenic trace mineral supplement with 11 essential trace elements needed for optimal health. This formula is iron-free for those who don't need extra iron from supplements."
    },
    {
     "name": "Vegan Glucosamine",
     "dose": "1000mg",
     "summary": "1000mg vegan Glucosamine supports overall joint function, repair, and maintenance of connective tissue."
    },
    {
     "name": "Vitamin C",
     "dose": "1000mg",
     "summary": "1000mg Vitamin C helps to support the production of collagen, connective tissue, bone, cartilage, and red blood cells as well as strengthen immune function."
    }
   ]
  },
  "longevity-pack": {
   "name": "Longevity Pack",
   "pills": [
    {
     "name": "CoQ10",
     "dose": "200mg",
     "summary": "200mg CoEnzyme Q-10 is a key component of energy production for every cell in the body. It provides significant antioxidant protection as well as supports cardiovascular health, athletic performance, and immune function."
    },
    {
     "name": "Green Tea Extract",
     "dose": "300mg",
     "summary": "300mg Green Tea extract is rich in antioxidants and catechins such as epigallocatechin gallate (EGCG) that help neutralize free radicals in the body, reducing oxidative stress and supporting overall health."
    },
    {
     "name": "NAC",
     "dose": "600mg",
     "summary": "600mg N-Acetyl Cysteine supports the master antioxidant glutathione in protecting DNA, aids liver detoxification, and maintains healthy respiratory tissue."
    },
    {
     "name": "NR",
     "dose": "500mg",
     "summary": "500mg Nicotinamide Riboside (NR) supplement, designed to boost NAD+ levels, is critical for cellular metabolism and energy production."
    },
    {
     "name": "Quercetin",
     "dose": "500mg",
     "summary": "500mg Quercetin is a flavonoid used for its antioxidant and anti-inflammatory properties."
    },
    {
     "name": "Resveratrol",
     "dose": "250mg",
     "summary": "250mg Resveratrol promotes cardiovascular and cognitive health, mitochondrial function, and antioxidant support."
    }
   ]
  },
  "mens-hormone-pack": {
   "name": "Men's Hormone Pack",
   "pills": [
    {
     "name": "Boron",
     "dose": "10mg",
     "summary": "10mg Boron is a trace mineral, supporting healthy bone strength and structure. Promotes steroidal hormone balance."
    },
    {
     "name": "DHEA",
     "dose": "25mg",
     "summary": "25mg DHEA is a naturally occurring hormone that plays a role in maintaining hormonal balance and overall well-being. It is commonly used to support energy levels, mood, and healthy aging."
    },
    {
     "name": "DIM",
     "dose": "300mg",
     "summary": "300mg DIM is used to support estrogen metabolism in both men and women."
    },
    {
     "name": "Fenugreek",
     "dose": "500mg",
     "summary": "500mg Fenugreek is an herb that helps support weight management, appetite control, blood sugar regulation, cholesterol management, and testosterone production."
    },
    {
     "name": "Tribulus",
     "dose": "500mg",
     "summary": "500mg Tribulus Terrestris improves testosterone levels and exercise performance."
    },
    {
     "name": "Zinc",
     "dose": "25mg",
     "summary": "25mg Zinc Picolinate is an essential mineral that plays a crucial role in various physiological functions within the body including our immune system."
    }
   ]
  },
  "mens-wellness": {
   "name": "Men's Wellness",
   "pills": [
    {
     "name": "10B Probiotic",
     "dose": "10 billion",
     "summary": "10 billion live probiotic cultures support digestive health and a balanced gut microbiome. Includes Lactobacillus and Bifidobacterium strains, and prebiotic fibers like inulin and FOS to help nourish beneficial bacteria and enhance their effectiveness."
    },
    {
     "name": "Ashwagandha",
     "dose": "500mg",
     "summary": "500mg Ashwagandha root and extract formula is an adaptogen that supports stress & anxiety, muscle function & strength, testosterone production, focus, and memory."
    },
    {
     "name": "CoQ10",
     "dose": "200mg",
     "summary": "200mg CoEnzyme Q-10 is a key component of energy production for every cell in the body. It provides significant antioxidant protection as well as supports cardiovascular health, athletic performance, and immune function."
    },
    {
     "name": "D Complex",
     "dose": "5,000 IU/125 mcg",
     "summary": "5,000 IU/125 mcg vitamin D3 balanced with the fat-soluble vitamins, A, E, K2 (MK-4 & MK-7), for optimal utilization."
    },
    {
     "name": "Methyl B-Complex",
     "dose": "",
     "summary": "B3 along with seven other B vitamins provide a complete range of essential B vitamins in their coenzymated (active) forms."
    },
    {
     "name": "Multivitamin",
     "dose": "",
     "summary": "A powerful multivitamin that provides an optimal nutritional foundation."
    },
    {
     "name": "Omega 3",
     "dose": "1000mg",
     "summary": "1000mg Omega-3 fatty acids support heart health, and aid in the function of the brain, liver, muscles, and joints. This omega-3 formula has been molecularly distilled to remove PCBs, dioxins, pesticides, and heavy metals."
    }
   ]
  },
  "microbiome-pack": {
   "name": "Microbiome Pack",
   "pills": [
    {
     "name": "10B Probiotic",
     "dose": "10 billion",
     "summary": "10 billion live probiotic cultures support digestive health and a balanced gut microbiome. Includes Lactobacillus and Bifidobacterium strains, and prebiotic fibers like inulin and FOS to help nourish beneficial bacteria and enhance their effectiveness."
    },
    {
     "name": "Berberine",
     "dose": "300mg",
     "summary": "300mg Berberine supports the cardiovascular system, weight management, cellular function, & healthy blood sugar levels."
    },
    {
     "name": "Quercetin",
     "dose": "500mg",
     "summary": "500mg Quercetin is a flavonoid used for its antioxidant and anti-inflammatory properties."
    },
    {
     "name": "Resveratrol",
     "dose": "250mg",
     "summary": "250mg Resveratrol promotes cardiovascular and cognitive health, mitochondrial function, and antioxidant support."
    },
    {
     "name": "Soothing Fiber Formula",
     "dose": "350mg",
     "summary": "350mg - This soluble fiber blend of aloe, marshmallow, and slippery elm is a potent gut soother for both constipation and diarrhea."
    },
    {
     "name": "Turmeric",
     "dose": "700 mg",
     "summary": "700 mg Turmeric is a high potency capsule utilizing C3 Complex®--the most clinically studied turmeric on the market."
    }
   ]
  },
  "mineral-pack": {
   "name": "Mineral Pack",
   "pills": [
    {
     "name": "Boron",
     "dose": "10mg",
     "summary": "10mg Boron is a trace mineral, supporting healthy bone strength and structure. Promotes steroidal hormone balance."
    },
    {
     "name": "Calcium Citrate",
     "dose": "160mg",
     "summary": "160mg - Highly bioavailable calcium to support bone mineral composition and bone health."
    },
    {
     "name": "Magnesium",
     "dose": "133mg",
     "summary": "133mg Magnesium Glycinate is a highly bioavailable essential mineral that supports muscle relaxation, without causing digestive upset."
    },
    {
     "name": "Trace Minerals",
     "dose": "",
     "summary": "A comprehensive, hypoallergenic trace mineral supplement with 11 essential trace elements needed for optimal health. This formula is iron-free for those who don't need extra iron from supplements."
    }
   ]
  },
  "mood-support-pack": {
   "name": "Mood Support Pack",
   "pills": [
    {
     "name": "Ashwagandha",
     "dose": "500mg",
     "summary": "500mg Ashwagandha root and extract formula is an adaptogen that supports stress & anxiety, muscle function & strength, testosterone production, focus, and memory."
    },
    {
     "name": "Magnesium",
     "dose": "133mg",
     "summary": "133mg Magnesium Glycinate is a highly bioavailable essential mineral that supports muscle relaxation, without causing digestive upset."
    },
    {
     "name": "Methyl B-Complex",
     "dose": "",
     "summary": "B3 along with seven other B vitamins provide a complete range of essential B vitamins in their coenzymated (active) forms."
    },
    {
     "name": "Rhodiola",
     "dose": "250mg",
     "summary": "250mg Rhodiola Rosea is an adaptogenic herb used to improve energy and aid the stress response."
    },
    {
     "name": "Theanine",
     "dose": "200mg",
     "summary": "200mg Theanine helps decrease stress and uplift mood by increasing levels of GABA, serotonin and dopamine."
    },
    {
     "name": "Zinc",
     "dose": "25mg",
     "summary": "25mg Zinc Picolinate is an essential mineral that plays a crucial role in various physiological functions within the body including our immune system."
    }
   ]
  },
  "muscle-preserve-pack": {
   "name": "Muscle Preserve Pack",
   "pills": [
    {
     "name": "BCAA",
     "dose": "600mg",
     "summary": "600mg Branched-Chain Amino Acid, high potency vegan formula to support lean muscle mass, exercise recovery, immune function and healthy aging."
    },
    {
     "name": "Carnitine",
     "dose": "500mg",
     "summary": "500mg Carnitine Tartrate is an amino acid used for exercise performance and weight management."
    },
    {
     "name": "Creatine",
     "dose": "750mg",
     "summary": "750mg Creatine Monohydrate is used to improve exercise performance, increase muscle mass, support muscle recovery, and aid neuroprotection."
    },
    {
     "name": "DHEA",
     "dose": "25mg",
     "summary": "25mg DHEA is a naturally occurring hormone that plays a role in maintaining hormonal balance and overall well-being. It is commonly used to support energy levels, mood, and healthy aging."
    },
    {
     "name": "Magnesium",
     "dose": "133mg",
     "summary": "133mg Magnesium Glycinate is a highly bioavailable essential mineral that supports muscle relaxation, without causing digestive upset."
    },
    {
     "name": "Zinc",
     "dose": "25mg",
     "summary": "25mg Zinc Picolinate is an essential mineral that plays a crucial role in various physiological functions within the body including our immune system."
    }
   ]
  },
  "pms-pack": {
   "name": "PMS Pack",
   "pills": [
    {
     "name": "Ashwagandha",
     "dose": "500mg",
     "summary": "500mg Ashwagandha root and extract formula is an adaptogen that supports stress & anxiety, muscle function & strength, testosterone production, focus, and memory."
    },
    {
     "name": "Calcium Citrate",
     "dose": "160mg",
     "summary": "160mg - Highly bioavailable calcium to support bone mineral composition and bone health."
    },
    {
     "name": "DIM",
     "dose": "300mg",
     "summary": "300mg DIM is used to support estrogen metabolism in both men and women."
    },
    {
     "name": "Magnesium",
     "dose": "133mg",
     "summary": "133mg Magnesium Glycinate is a highly bioavailable essential mineral that supports muscle relaxation, without causing digestive upset."
    },
    {
     "name": "Methyl B-Complex",
     "dose": "",
     "summary": "B3 along with seven other B vitamins provide a complete range of essential B vitamins in their coenzymated (active) forms."
    },
    {
     "name": "Omega 3",
     "dose": "1000mg",
     "summary": "1000mg Omega-3 fatty acids support heart health, and aid in the function of the brain, liver, muscles, and joints. This omega-3 formula has been molecularly distilled to remove PCBs, dioxins, pesticides, and heavy metals."
    }
   ]
  },
  "performance-pack": {
   "name": "Performance Pack",
   "pills": [
    {
     "name": "BCAA",
     "dose": "600mg",
     "summary": "600mg Branched-Chain Amino Acid, high potency vegan formula to support lean muscle mass, exercise recovery, immune function and healthy aging."
    },
    {
     "name": "Carnitine",
     "dose": "500mg",
     "summary": "500mg Carnitine Tartrate is an amino acid used for exercise performance and weight management."
    },
    {
     "name": "Cordyceps",
     "dose": "500mg",
     "summary": "500mg Cordyceps Mushrooms extract supports aids performance by enhancing oxygen utilization and energy production."
    },
    {
     "name": "Creatine",
     "dose": "750mg",
     "summary": "750mg Creatine Monohydrate is used to improve exercise performance, increase muscle mass, support muscle recovery, and aid neuroprotection."
    },
    {
     "name": "NR",
     "dose": "500mg",
     "summary": "500mg Nicotinamide Riboside (NR) supplement, designed to boost NAD+ levels, is critical for cellular metabolism and energy production."
    },
    {
     "name": "Rhodiola",
     "dose": "250mg",
     "summary": "250mg Rhodiola Rosea is an adaptogenic herb used to improve energy and aid the stress response."
    }
   ]
  },
  "perimenopause-pack": {
   "name": "Perimenopause Pack",
   "pills": [
    {
     "name": "Cordyceps",
     "dose": "500mg",
     "summary": "500mg Cordyceps Mushrooms extract supports aids performance by enhancing oxygen utilization and energy production."
    },
    {
     "name": "DHEA",
     "dose": "25mg",
     "summary": "25mg DHEA is a naturally occurring hormone that plays a role in maintaining hormonal balance and overall well-being. It is commonly used to support energy levels, mood, and healthy aging."
    },
    {
     "name": "DIM",
     "dose": "300mg",
     "summary": "300mg DIM is used to support estrogen metabolism in both men and women."
    },
    {
     "name": "Fenugreek",
     "dose": "500mg",
     "summary": "500mg Fenugreek is an herb that helps support weight management, appetite control, blood sugar regulation, cholesterol management, and testosterone production."
    },
    {
     "name": "Magnesium",
     "dose": "133mg",
     "summary": "133mg Magnesium Glycinate is a highly bioavailable essential mineral that supports muscle relaxation, without causing digestive upset."
    }
   ]
  },
  "sleep-pack": {
   "name": "Sleep Pack",
   "pills": [
    {
     "name": "Herbal Sleep Blend",
     "dose": "450mg",
     "summary": "450mg - This herbal formula combines poppy, hops, passionflower, skullcap, and valerian to promote relaxation and enhance sleep."
    },
    {
     "name": "Magnesium",
     "dose": "133mg",
     "summary": "133mg Magnesium Glycinate is a highly bioavailable essential mineral that supports muscle relaxation, without causing digestive upset."
    },
    {
     "name": "Melatonin SR",
     "dose": "2mg",
     "summary": "2mg Melatonin SR is a vegan, sustained-release format to promote healthy sleep by supporting the body’s circadian rhythm, endocrine secretions, and sleep patterns."
    },
    {
     "name": "Theanine",
     "dose": "200mg",
     "summary": "200mg Theanine helps decrease stress and uplift mood by increasing levels of GABA, serotonin and dopamine."
    }
   ]
  },
  "sleep-pack-1": {
   "name": "Sleep Pack (no Melatonin)",
   "pills": [
    {
     "name": "Herbal Sleep Blend",
     "dose": "450mg",
     "summary": "450mg - This herbal formula combines poppy, hops, passionflower, skullcap, and valerian to promote relaxation and enhance sleep."
    },
    {
     "name": "Magnesium",
     "dose": "133mg",
     "summary": "133mg Magnesium Glycinate is a highly bioavailable essential mineral that supports muscle relaxation, without causing digestive upset."
    },
    {
     "name": "Theanine",
     "dose": "200mg",
     "summary": "200mg Theanine helps decrease stress and uplift mood by increasing levels of GABA, serotonin and dopamine."
    }
   ]
  },
  "stress-pack": {
   "name": "Stress Pack",
   "pills": [
    {
     "name": "Ashwagandha",
     "dose": "500mg",
     "summary": "500mg Ashwagandha root and extract formula is an adaptogen that supports stress & anxiety, muscle function & strength, testosterone production, focus, and memory."
    },
    {
     "name": "Cordyceps",
     "dose": "500mg",
     "summary": "500mg Cordyceps Mushrooms extract supports aids performance by enhancing oxygen utilization and energy production."
    },
    {
     "name": "Magnesium",
     "dose": "133mg",
     "summary": "133mg Magnesium Glycinate is a highly bioavailable essential mineral that supports muscle relaxation, without causing digestive upset."
    },
    {
     "name": "Methyl B-Complex",
     "dose": "",
     "summary": "B3 along with seven other B vitamins provide a complete range of essential B vitamins in their coenzymated (active) forms."
    },
    {
     "name": "Omega 3",
     "dose": "1000mg",
     "summary": "1000mg Omega-3 fatty acids support heart health, and aid in the function of the brain, liver, muscles, and joints. This omega-3 formula has been molecularly distilled to remove PCBs, dioxins, pesticides, and heavy metals."
    },
    {
     "name": "Theanine",
     "dose": "200mg",
     "summary": "200mg Theanine helps decrease stress and uplift mood by increasing levels of GABA, serotonin and dopamine."
    }
   ]
  },
  "vegan-nutrient-pack": {
   "name": "Vegan Nutrient Pack",
   "pills": [
    {
     "name": "Calcium Citrate",
     "dose": "160mg",
     "summary": "160mg - Highly bioavailable calcium to support bone mineral composition and bone health."
    },
    {
     "name": "D Complex",
     "dose": "5,000 IU/125 mcg",
     "summary": "5,000 IU/125 mcg vitamin D3 balanced with the fat-soluble vitamins, A, E, K2 (MK-4 & MK-7), for optimal utilization."
    },
    {
     "name": "Iron",
     "dose": "18 mg",
     "summary": "18 mg Iron from Ferrous Bisglycinate Ferrochel® plays a key role in the function of red blood cells' ability to carry oxygen, without causing digestive upset."
    },
    {
     "name": "Methyl B-Complex",
     "dose": "",
     "summary": "B3 along with seven other B vitamins provide a complete range of essential B vitamins in their coenzymated (active) forms."
    },
    {
     "name": "Trace Minerals",
     "dose": "",
     "summary": "A comprehensive, hypoallergenic trace mineral supplement with 11 essential trace elements needed for optimal health. This formula is iron-free for those who don't need extra iron from supplements."
    },
    {
     "name": "Vegan Omega",
     "dose": "275mg",
     "summary": "275mg of plant-based essential fatty acids, EPA and DHA, sourced from algal oil for a sustainable alternative to fish-derived options. Formulated for easy absorption, it offers a convenient way to support overall wellness as part of a balanced diet."
    },
    {
     "name": "Zinc",
     "dose": "25mg",
     "summary": "25mg Zinc Picolinate is an essential mineral that plays a crucial role in various physiological functions within the body including our immune system."
    }
   ]
  },
  "womens-hormone-pack": {
   "name": "Women's Hormone Pack",
   "pills": [
    {
     "name": "Cordyceps",
     "dose": "500mg",
     "summary": "500mg Cordyceps Mushrooms extract supports aids performance by enhancing oxygen utilization and energy production."
    },
    {
     "name": "DHEA",
     "dose": "25mg",
     "summary": "25mg DHEA is a naturally occurring hormone that plays a role in maintaining hormonal balance and overall well-being. It is commonly used to support energy levels, mood, and healthy aging."
    },
    {
     "name": "DIM",
     "dose": "300mg",
     "summary": "300mg DIM is used to support estrogen metabolism in both men and women."
    },
    {
     "name": "Fenugreek",
     "dose": "500mg",
     "summary": "500mg Fenugreek is an herb that helps support weight management, appetite control, blood sugar regulation, cholesterol management, and testosterone production."
    },
    {
     "name": "Omega 3",
     "dose": "1000mg",
     "summary": "1000mg Omega-3 fatty acids support heart health, and aid in the function of the brain, liver, muscles, and joints. This omega-3 formula has been molecularly distilled to remove PCBs, dioxins, pesticides, and heavy metals."
    }
   ]
  },
  "womens-wellness": {
   "name": "Women's Wellness",
   "pills": [
    {
     "name": "10B Probiotic",
     "dose": "10 billion",
     "summary": "10 billion live probiotic cultures support digestive health and a balanced gut microbiome. Includes Lactobacillus and Bifidobacterium strains, and prebiotic fibers like inulin and FOS to help nourish beneficial bacteria and enhance their effectiveness."
    },
    {
     "name": "Ashwagandha",
     "dose": "500mg",
     "summary": "500mg Ashwagandha root and extract formula is an adaptogen that supports stress & anxiety, muscle function & strength, testosterone production, focus, and memory."
    },
    {
     "name": "D Complex",
     "dose": "5,000 IU/125 mcg",
     "summary": "5,000 IU/125 mcg vitamin D3 balanced with the fat-soluble vitamins, A, E, K2 (MK-4 & MK-7), for optimal utilization."
    },
    {
     "name": "Multivitamin",
     "dose": "",
     "summary": "A powerful multivitamin that provides an optimal nutritional foundation."
    },
    {
     "name": "Omega 3",
     "dose": "1000mg",
     "summary": "1000mg Omega-3 fatty acids support heart health, and aid in the function of the brain, liver, muscles, and joints. This omega-3 formula has been molecularly distilled to remove PCBs, dioxins, pesticides, and heavy metals."
    },
    {
     "name": "Vitamin C",
     "dose": "1000mg",
     "summary": "1000mg Vitamin C helps to support the production of collagen, connective tissue, bone, cartilage, and red blood cells as well as strengthen immune function."
    }
   ]
  }
 }
};
